module.exports = __webpack_public_path__ + "img/py.9928c580.jpg";